"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCampaignProductsSkus = exports.CAMPAIGN_PRODUCTS_INITIAL_VALUE = exports.PRODUCTS_INITIAL_VALUE = void 0;
const react_1 = require("react");
const useFeatureFlag_1 = require("../../hooks/useFeatureFlag");
const types_1 = require("../../types");
const utils_1 = require("../utils");
const CAMPAIGN_PRODUCTS_FEATURE_FLAG_KEY = 'campaignProducts';
exports.PRODUCTS_INITIAL_VALUE = {
    kits: [],
    selectedProducts: [],
};
exports.CAMPAIGN_PRODUCTS_INITIAL_VALUE = {
    boticario: exports.PRODUCTS_INITIAL_VALUE,
    euamomake: exports.PRODUCTS_INITIAL_VALUE,
    eudora: exports.PRODUCTS_INITIAL_VALUE,
    oui: exports.PRODUCTS_INITIAL_VALUE,
};
const CAMPAIGN_BRANDS = [types_1.BusinessUnit.BOT, types_1.BusinessUnit.EUD, types_1.BusinessUnit.EAM, types_1.BusinessUnit.OUI];
const useCampaignProductsSkus = () => {
    const [featureFlagValue, loading] = (0, useFeatureFlag_1.useFeatureFlag)(CAMPAIGN_PRODUCTS_FEATURE_FLAG_KEY, null);
    const [campaignProducts, setCampaignProducts] = (0, react_1.useState)(exports.CAMPAIGN_PRODUCTS_INITIAL_VALUE);
    (0, react_1.useEffect)(() => {
        if (loading || !featureFlagValue) {
            return;
        }
        const products = CAMPAIGN_BRANDS.reduce((acc, businessUnit) => {
            const parsedConfig = (0, utils_1.parseAndGetKeyValueConfig)(featureFlagValue, {
                key: businessUnit,
                schema: utils_1.campaignProductsConfigSchema,
            });
            if (parsedConfig) {
                acc[businessUnit] = parsedConfig;
            }
            return acc;
        }, Object.assign({}, exports.CAMPAIGN_PRODUCTS_INITIAL_VALUE));
        setCampaignProducts(products);
    }, [loading, featureFlagValue]);
    return campaignProducts;
};
exports.useCampaignProductsSkus = useCampaignProductsSkus;
